import React from 'react'
import Dashboard from '../dashboard'
import ReportView from './page'

const Report = () => {
  return <Dashboard component={<ReportView />} />
}

export default Report
